/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Serializer for confirming a password reset attempt.
*/
export class PasswordResetConfirmRequest {
    'newPassword1': string;
    'newPassword2': string;
    'uid': string;
    'token': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "newPassword1",
            "baseName": "newPassword1",
            "type": "string",
            "format": ""
        },
        {
            "name": "newPassword2",
            "baseName": "newPassword2",
            "type": "string",
            "format": ""
        },
        {
            "name": "uid",
            "baseName": "uid",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PasswordResetConfirmRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

